export default "__VITE_ASSET__eBobOVK5__"